
import Vue from "vue";
import bus from '../service/bus';

export default Vue.extend({
  name: "Header",
  data() {
    return {
      lang: "en",
      nav: "Home"
    };
  },
  created() {
    if(localStorage.getItem("lang")){
      this.setLanguage(localStorage.getItem("lang"));
    }
  },
  methods: {
    setLanguage(lang: any) {
      this.lang = lang;
      this.$i18n.locale = this.lang;
      localStorage.setItem("lang", this.lang);
      bus.$emit('changLanguage');
    },
    changeMenu(nav:string){
      this.nav = nav;
      console.log(this.nav)
    },
    getPath(){
      let path = this.$route.path;
      if(path.indexOf('Home')!=-1){
        this.nav = "Home";
      }else if(path.indexOf('Browse')!=-1){
        this.nav = "Browse";
      }else if(path.indexOf('Visualization')!=-1){
        this.nav = "Visualization";
      }else if(path.indexOf('Tools')!=-1){
        this.nav = "Tools";
      }else if(path.indexOf('Help')!=-1){
        this.nav = "Help";
      }
    }
  },
  watch: {
    '$route':'getPath'
  }
});
